import React, { useRef, useCallback, useEffect } from 'react';
import { snapVal } from './helpers.jsx';
import { SNAP_SIZE,libFind,C } from './constants.jsx';

export default function DragWrapper({ comp, selected, snapOn, onSelect, onUpdate, children }) {
  const dragRef = useRef(null);
  const resizeSERef = useRef(null);
  const resizeERef = useRef(null);
  const compRef = useRef(comp);
  useEffect(() => { compRef.current = comp; }, [comp]);

  const onMouseDownDrag = useCallback((e) => {
    if (e.target.dataset.noDrag) return;
    e.stopPropagation();
    onSelect();
    const { x, y } = compRef.current;
    dragRef.current = { sx: e.clientX, sy: e.clientY, ox: x, oy: y };

    const onMove = (ev) => {
      if (!dragRef.current) return;
      const scale = compRef.current._zoom || 1;
      onUpdate({
        x: snapVal(Math.max(0, dragRef.current.ox + (ev.clientX - dragRef.current.sx) / scale), SNAP_SIZE, snapOn),
        y: snapVal(Math.max(0, dragRef.current.oy + (ev.clientY - dragRef.current.sy) / scale), SNAP_SIZE, snapOn),
      });
    };
    const onUp = () => {
      dragRef.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, [onSelect, onUpdate, snapOn]);

  const onMouseDownSE = useCallback((e) => {
    e.stopPropagation();
    const cur = compRef.current;
    const ow = typeof cur.w === 'number' ? cur.w : 300;
    const oh = typeof cur.h === 'number' ? cur.h : 100;
    resizeSERef.current = { sx: e.clientX, sy: e.clientY, ow, oh };

    const onMove = (ev) => {
      if (!resizeSERef.current) return;
      const scale = compRef.current._zoom || 1;
      const dx = (ev.clientX - resizeSERef.current.sx) / scale;
      const dy = (ev.clientY - resizeSERef.current.sy) / scale;
      onUpdate({
        w: snapVal(Math.max(60, resizeSERef.current.ow + dx), SNAP_SIZE, snapOn),
        h: snapVal(Math.max(30, resizeSERef.current.oh + dy), SNAP_SIZE, snapOn),
      });
    };
    const onUp = () => {
      resizeSERef.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, [onUpdate, snapOn]);

  const onMouseDownE = useCallback((e) => {
    e.stopPropagation();
    const ow = typeof compRef.current.w === 'number' ? compRef.current.w : 300;
    resizeERef.current = { sx: e.clientX, ow };

    const onMove = (ev) => {
      if (!resizeERef.current) return;
      const scale = compRef.current._zoom || 1;
      const w = snapVal(Math.max(60, resizeERef.current.ow + (ev.clientX - resizeERef.current.sx) / scale), SNAP_SIZE, snapOn);
      onUpdate({ w });
    };
    const onUp = () => {
      resizeERef.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, [onUpdate, snapOn]);

  const ew = typeof comp.w === 'number' ? comp.w : 300;
  const eh = typeof comp.h === 'number' ? comp.h : undefined;

  return (
    <div
      onMouseDown={onMouseDownDrag}
      style={{
        position: 'absolute', left: comp.x, top: comp.y,
        width: ew, height: eh,
        cursor: 'grab',
        outline: selected ? `2px solid ${C.accent}` : '2px solid transparent',
        outlineOffset: 2, borderRadius: 4,
        userSelect: 'none', transition: 'outline .1s',
      }}
    >
      {children}

      {selected && (
        <>
          {/* Label chip */}
          <div style={{
            position: 'absolute', top: -21, left: 0,
            background: C.accent, color: '#fff', fontSize: 10, fontWeight: 600,
            padding: '2px 8px', borderRadius: '3px 3px 0 0',
            whiteSpace: 'nowrap', pointerEvents: 'none',
          }}>
            {libFind(comp.type).label}
          </div>

          {/* SE resize handle */}
          <div
            data-no-drag="true"
            onMouseDown={onMouseDownSE}
            style={{
              position: 'absolute', bottom: -5, right: -5,
              width: 13, height: 13, background: C.accent,
              borderRadius: 3, cursor: 'se-resize', border: '2px solid #fff',
              boxShadow: '0 1px 4px rgba(0,0,0,.2)', zIndex: 10,
            }}
          />

          {/* E resize handle */}
          <div
            data-no-drag="true"
            onMouseDown={onMouseDownE}
            style={{
              position: 'absolute', top: '15%', right: -4,
              width: 7, height: '70%', background: C.accentMd,
              borderRadius: 4, cursor: 'e-resize', opacity: 0.8,
            }}
          />
        </>
      )}
    </div>
  );
}
